module.exports = __webpack_public_path__ + "static/zlotnik-hex-gray-2121735f1aa1a7a892bf5c099016fb3c.png";